// Display Component for Correspondence Objs in Tickets

import { NoteCard } from "@components/note-card";

type CorrespondenceBoxProps = {
  sender_email: string;
  note_text: string;
  body_html?: string;
  date: string;
  visibility: string;
};

const formatSenderName = (sender: string) => {
  const username = sender.includes("@") ? sender.split("@")[0] : sender;
  return username
    .split(/[._-]+/)
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(" ");
};

export const CorrespondenceBox = ({
  sender_email,
  note_text,
  body_html,
  date,
  visibility,
}: CorrespondenceBoxProps) => {
  return (
    <NoteCard
      noteText={note_text}
      bodyHtml={body_html}
      date={date}
      visibility={visibility}
      senderLabel={formatSenderName(sender_email)}
      showVisibilityTag
    />
  );
};
